import { db } from './config';
// Импортируем, сука, ВСЕ, что нам нужно для Firebase v9+
import { 
    collection, 
    getDocs, 
    query, 
    where, 
    orderBy, 
    limit, 
    addDoc, 
    doc, 
    setDoc, 
    serverTimestamp 
} from 'firebase/firestore'; 

const PRODUCTS_COLLECTION = 'siteproducts';
const CATEGORIES_COLLECTION = 'categories';

/**
 * Получает ВСЕ товары из Firestore ОДНИМ БЫСТРЫМ ЗАПРОСОМ.
 */
export const getProducts = async () => {
    try {
        const productsRef = collection(db, PRODUCTS_COLLECTION);
        const q = query(productsRef, orderBy('created_time', 'desc'));

        // Отправляем getDocs для товаров
        const querySnapshot = await getDocs(q); // Это синтаксис v9

        const products = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
        // Товары получены
        return products;
    } catch (error) {
        throw error;
    }
};

/**
 * Получает все КАТЕГОРИИ из Firestore ОДНИМ БЫСТРЫМ ЗАПРОСОМ.
 */
export const getCategories = async () => {
    try {
        const categoriesRef = collection(db, CATEGORIES_COLLECTION);
        // ЗАПРОС С ФИЛЬТРОМ: берем только активные и сортируем по порядку
        const q = query(categoriesRef, where('isActive', '==', true), orderBy('order', 'asc')); 

        // Отправляем getDocs для категорий
        const querySnapshot = await getDocs(q); // Это синтаксис v9

        const categories = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
        // Активные категории получены
        return categories;
    } catch (error) {
        throw error;
    }
};

/**
 * Получает товар по ID
 */
export const getProductById = async (productId) => {
    try {
        // Загрузка товара по ID
        const productsRef = collection(db, PRODUCTS_COLLECTION);
        // __name__ это специальное поле Firebase для поиска по ID документа
        const q = query(productsRef, where('__name__', '==', productId));
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
            throw new Error(`Товар с ID "${productId}" не найден`);
        }
        const doc = querySnapshot.docs[0];
        // Товар с ID успешно найден
        return { id: doc.id, ...doc.data() };
    } catch (error) {
        throw error;
    }
};

/**
 * Получает товары с фильтрацией
 */
export const getFilteredProducts = async (filters = {}, limitCount = 10) => {
    try {
        // Загрузка отфильтрованных товаров с фильтрами
        const productsRef = collection(db, PRODUCTS_COLLECTION);
        let q = query(productsRef, orderBy('created_time', 'desc'));

        if (filters.minPrice) { q = query(q, where('price', '>=', Number(filters.minPrice))); }
        if (filters.maxPrice) { q = query(q, where('price', '<=', Number(filters.maxPrice))); }
        if (filters.size) { q = query(q, where('size', '==', filters.size)); }

        q = query(q, limit(limitCount));
        const querySnapshot = await getDocs(q);
        const products = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        // Загружено отфильтрованных товаров
        return products;
    } catch (error) {
        throw error;
    }
};

/**
 * Проверяет существование коллекции products
 */
export const checkProductsCollectionExists = async () => {
    try {
        // Проверка существования коллекции
        const productsRef = collection(db, PRODUCTS_COLLECTION);
        const q = query(productsRef, limit(1));
        const querySnapshot = await getDocs(q);
        const exists = !querySnapshot.empty;
        // Коллекция проверена
        return exists;
    } catch (error) {
        return false;
    }
};

/**
 * Добавляет новый товар в Firestore
 */
export const addProduct = async (productData) => {
    try {
        // Добавление нового товара
        const productsRef = collection(db, PRODUCTS_COLLECTION);
        const docRef = await addDoc(productsRef, {
            ...productData,
            created_time: serverTimestamp() 
        });
        // Новый товар успешно добавлен
        return docRef.id;
    } catch (error) {
        throw error;
    }
};

/**
 * Добавляет новую категорию в Firestore
 */
export const addCategory = async (categoryId, categoryData) => {
    try {
        // Добавление новой категории
        const categoryDocRef = doc(db, CATEGORIES_COLLECTION, categoryId);
        await setDoc(categoryDocRef, categoryData);
        // Новая категория успешно добавлена
        return categoryId;
    } catch (error) {
        throw error;
    }
};